import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { Filter, toFilterXml } from '../../dataObjects/Filter';
import { Order, toOrderXml } from '../../dataObjects/Order';

export interface IListMessageActionRequest extends IBaseRequest {
    limit?:      number;
    offset?:     number;
    orderBy?:    string;
    countOnly?:  string;
    treeHandle?: string;
    FILTER?:     Filter;
    ORDER?:      Order;
}

export class ListMessageActionRequest extends BaseRequest implements IListMessageActionRequest {

    public limit?:      number;
    public offset?:     number;
    public orderBy?:    string;
    public countOnly?:  string;
    public treeHandle?: string;
    public FILTER?:     Filter;
    public ORDER?:      Order;

    constructor(server: string, session: string, otherOptions: any ) {
        super(server, session);

        this.limit      = otherOptions.limit;
        this.offset     = otherOptions.offset;
        this.orderBy    = otherOptions.orderBy;
        this.countOnly  = otherOptions.countOnly;
        this.treeHandle = otherOptions.treeHandle;
        this.FILTER     = otherOptions.FILTER;
        this.ORDER      = otherOptions.ORDER;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.orderBy, 'orderBy');
        parameters += this.makeNode(this.countOnly, 'countOnly');
        parameters += this.makeNode(this.treeHandle, 'treeHandle');
        if (this.FILTER)     parameters += toFilterXml(this.FILTER);
        if (this.ORDER)      parameters += toOrderXml(this.ORDER);

        return super.wrapperXml('ListMessageAction', parameters);
    }
}
